import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AddElectivesComponent from './AddElectivesComponent';
import { MuiTypography, MuiGrid, MuiFab, MuiTextField, MuiEdit, MuiButton, MuiAddCircle, MuiPaper } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import spinner from "../../../ui/icons/spinner.gif"
import PageHeaderComponent from '../../../ui/PageHeaderComponent'
import '../../../ui/scrollbarForLog.css'

const styles = () => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(1),
    overflowX: 'auto',
  },
  table: {
    minWidht: 900,

  },
  fab: {
    margin: theme.spacing(1)
  },
});


export class ElectivesComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggleChange: false,
      activeSchool: props.activeSchool,
    }
  }

  renderAddRow = () => {
    let electives = this.props.electives;
    this.updateData()
    let color = theme.colorCatalogue[electives.length % theme.colorCatalogue.length]
    electives.push({
      id: electives.length + 1,
      name: null,
      color: color,

      subjects: [],
      gradeDetails: {
        allGrades: true,
        gradeLevels: [],
        grades: []
      }
    });
    this.setState({ electives: electives });
  }


  updateData = () => {
    if (!this.props.confirmationDialog.isChanged) {
      this.props.confirmationDialog.isChanged = true
    }
    this.setState({ toggleChange: !this.state.toggleChange });

  }

  render() {
    const { classes, i18n } = this.props
    if (this.props.updateSchoolinformationInProgress === true || this.props.electives === undefined) {
      return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' ><img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
    }
    return (
      <MuiGrid container xs={12} >
        <PageHeaderComponent {...this.props} title={i18n.electives.title} subTitle={i18n.electives.tabDescription} />
        <MuiGrid container xs={12} >
          {/* <MuiGrid container xs={12}  style={theme.gridTableStyle} > */}
          <MuiGrid container xs={12} direction='row' style={theme.tableHeaderStyle}>
            <MuiGrid item xs={3} >
              <MuiTypography style={theme.tableHeaderTextStyle}>     {i18n.electives.electiveName}
              </MuiTypography></MuiGrid>
            <MuiGrid item xs={4} >
              <MuiTypography style={theme.tableHeaderTextStyle}>    {i18n.electives.electiveGradeDetail}
              </MuiTypography></MuiGrid>
            <MuiGrid item xs >
              <MuiTypography style={theme.tableHeaderTextStyle}>    {i18n.electives.subjectsForELective}
              </MuiTypography> </MuiGrid>

          </MuiGrid>

          <MuiGrid xs={12} id='scrollStyle' style={{ maxHeight: '62vh', overflowY: 'auto' }}>
            {this.props.electives.map((elective, index) =>
              <MuiGrid item xs={12} id="grid">
                <AddElectivesComponent
                  {...this.props}
                  {...this.state}
                  elective={elective}
                  index={index}
                  updateData={this.updateData}
                />
              </MuiGrid>
            )}
          </MuiGrid>
          <MuiGrid container xs={12} onClick={() => this.renderAddRow()} style={theme.gridActionContainerStyleForStickyButton} justify="center" alignItems="center">
            <MuiGrid item >
              <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />
            </MuiGrid>

            <MuiGrid item>
              <MuiTypography style={theme.addMoreStyle} >
                {i18n.electives.addMoreElectives}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>

          <MuiGrid container xs={12} style={{ height: '2vh' }}></MuiGrid>
          <MuiGrid container xs={12} justify="flex-end" >
            <MuiButton
              disabled={!this.props.confirmationDialog.isChanged}
              style={!this.props.confirmationDialog.isChanged ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
              onClick={() => { this.props.onClickOfSave() }}>
              {i18n.commonTexts.save}
            </MuiButton>
          </MuiGrid>
        </MuiGrid>
      </MuiGrid>
    )
  }
}

export default withStyles(styles)(ElectivesComponent)
